import { render, staticRenderFns } from "./AcikSatisSiparisleri.vue?vue&type=template&id=6a4dee34"
import script from "./AcikSatisSiparisleri.vue?vue&type=script&lang=js"
export * from "./AcikSatisSiparisleri.vue?vue&type=script&lang=js"
import style0 from "./AcikSatisSiparisleri.vue?vue&type=style&index=0&id=6a4dee34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports